import React, { useState, useContext, useEffect } from 'react'
import { useHistory } from 'react-router-dom'

import UserContext from '../../context/UserContext'

import api from '../../services/api'

import { makeStyles } from '@material-ui/core/styles'
import { TextField, Button, Icon } from '@material-ui/core'

import roundLogo from '../../assets/round-logo.png'
import './styles.css'

import { useAlert } from 'react-alert'

const useStyles = makeStyles({
    inputStyle: {
        margin: '5px'
    },
    buttonStyle: {
        margin: '5px',
        marginTop: '30px',
        marginBottom: '16px'
    }
})

function Cadastro() {
    const { userData, setUserData } = useContext(UserContext)
    const history = useHistory()
    const classes = useStyles()
    const alert = useAlert()

    const [nome, setNome] = useState('')
    const [email, setEmail] = useState('')
    const [senha, setSenha] = useState('')

    useEffect(() => {
        if(userData.user) {
            history.push('/perfil')
        }
    })

    const submitHandler = async (e) => {
        e.preventDefault()

        try {
            
            const newUser = { nome, email, senha }

            await api.post('/api/user/register', newUser)
            
            const loginRes = await api.post('/api/user/login', {
                email,
                senha
            })

            setUserData({
                token: loginRes.data.token,
                user: loginRes.data.user
            })

            localStorage.setItem('auth-token', loginRes.data.token)

            history.push("/perfil")

        } catch (err) {
            alert.show('Erro ao cadastrar usuário. Por favor, verifique os requisitos e tente novamente.', { title: "Algo deu errado.", closeCopy: "OK" })
        }
    }

    return (
        <div className="cadastro-container">
            <div>
                <center><img src={roundLogo} alt="Meu perfil" height="128px" width="128px" style={{borderRadius: "96px", margin: "30px"}} /></center>
                <form onSubmit={submitHandler}>
                    <TextField 
                        className={classes.inputStyle} 
                        label="Seu Nome" 
                        variant="outlined"
                        autoComplete="on"                   
                        required

                        value={nome}
                        onChange={e => setNome(e.target.value)}
                    />
                    <TextField 
                        className={classes.inputStyle} 
                        label="Seu@Email.com" 
                        variant="outlined" 
                        type="email"
                        autoComplete="on"
                        required

                        value={email}
                        onChange={e => setEmail(e.target.value)}
                    />
                    <TextField 
                        className={classes.inputStyle} 
                        label="Senha" 
                        variant="outlined" 
                        type="password"
                        helperText="Sua senha deve conter no mínimo 7 caracteres."
                        autoComplete="on"
                        required

                        value={senha}
                        onChange={e => setSenha(e.target.value)}
                    />
                    
                    <Button 
                        variant="contained" 
                        color="primary" 
                        endIcon={<Icon>send</Icon>} 
                        className={classes.buttonStyle}                         
                        type="submit"
                    >
                        Cadastrar
                    </Button>
                </form>
            </div>
        </div>
    )
}

export default Cadastro
